import { Role } from './types';

export enum Permission {
  ArrangeMonitors = 'ArrangeMonitors',
  SetTimeRangeMonitor = 'SetTimeRangeMonitor',
  ViewMonitorDetail = 'ViewMonitorDetail',
  ViewMonitorEventDetail = 'ViewMonitorEventDetail',
  DownloadOutreachEvent = 'DownloadOutreachEvent',
  AddMonitor = 'AddMonitor',
  EditMonitor = 'EditMonitor',
  DeleteMonitor = 'DeleteMonitor',
  AddIncludeExcludeFiles = 'AddIncludeExcludeFiles',
  DeleteIncludeExcludeFiles = 'DeleteIncludeExcludeFiles',
  ViewOutreachConfig = 'ViewOutreachConfig',
  EnableSupportEmailOutreach = 'EnableSupportEmailOutreach',
  EnableSupportWebhookOutreach = 'EnableSupportWebhookOutreach',
  EditSupportEmailOutreach = 'EditSupportEmailOutreach',
  EditSupportWebhookOutreach = 'EditSupportWebhookOutreach',
  ManageSupportEmailOutreachContent = 'ManageSupportEmailOutreachContent',
  ManageSupportWebhookOutreachContent = 'ManageSupportWebhookOutreachContent',
  TestSupportEmailOutreach = 'TestSupportEmailOutreach',
  TestSupportWebhookOutreach = 'TestSupportWebhookOutreach',
  ForceCloseSupportEmailOutreachEvent = 'ForceCloseSupportEmailOutreachEvent',
  ForceCloseSupportWebhookOutreachEvent = 'ForceCloseSupportWebhookOutreachEvent',
  EnableSubscriberPushOutreach = 'EnableSubscriberPushOutreach',
  EditSubscriberPushOutreach = 'EditSubscriberPushOutreach',
  EditSubscriberPushOutreachURLs = 'EditSubscriberPushOutreachURLs',
  TestSubscriberPushOutreach = 'TestSubscriberPushOutreach',
  ForceCloseSubscriberPushOutreachEvent = 'ForceCloseSubscriberPushOutreachEvent',
  ViewConfiguration = 'ViewConfiguration',
  ModifyConfiguration = 'ModifyConfiguration',
}

export type PermissionSet = {
  [key in Permission]: boolean;
};

export type rolePermissions = {
  [key in Role]: PermissionSet;
};

export const roleToPermissions: rolePermissions = {
  [Role.PartnerAdmin]: {
    [Permission.ArrangeMonitors]: true,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: true,
    [Permission.EditMonitor]: true,
    [Permission.DeleteMonitor]: true,
    [Permission.AddIncludeExcludeFiles]: true,
    [Permission.DeleteIncludeExcludeFiles]: true,
    [Permission.ViewOutreachConfig]: true,
    [Permission.EnableSupportEmailOutreach]: true,
    [Permission.EditSupportEmailOutreach]: true,
    [Permission.ManageSupportEmailOutreachContent]: true,
    [Permission.TestSupportEmailOutreach]: true,
    [Permission.ForceCloseSupportEmailOutreachEvent]: true,
    [Permission.EnableSupportWebhookOutreach]: true,
    [Permission.EditSupportWebhookOutreach]: true,
    [Permission.ManageSupportWebhookOutreachContent]: true,
    [Permission.TestSupportWebhookOutreach]: true,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: true,
    [Permission.EnableSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreachURLs]: true,
    [Permission.TestSubscriberPushOutreach]: true,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: true,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: true,
  },
  [Role.PartnerSupportEngineer]: {
    [Permission.ArrangeMonitors]: true,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: false,
    [Permission.EditMonitor]: false,
    [Permission.DeleteMonitor]: false,
    [Permission.AddIncludeExcludeFiles]: false,
    [Permission.DeleteIncludeExcludeFiles]: false,
    [Permission.ViewOutreachConfig]: false,
    [Permission.EnableSupportEmailOutreach]: false,
    [Permission.EditSupportEmailOutreach]: false,
    [Permission.ManageSupportEmailOutreachContent]: false,
    [Permission.TestSupportEmailOutreach]: false,
    [Permission.ForceCloseSupportEmailOutreachEvent]: false,
    [Permission.EnableSupportWebhookOutreach]: false,
    [Permission.EditSupportWebhookOutreach]: false,
    [Permission.ManageSupportWebhookOutreachContent]: false,
    [Permission.TestSupportWebhookOutreach]: false,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: false,
    [Permission.EnableSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreachURLs]: false,
    [Permission.TestSubscriberPushOutreach]: false,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: false,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: false,
  },
  [Role.PartnerSupportManagerExternal]: {
    [Permission.ArrangeMonitors]: true,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: true,
    [Permission.EditMonitor]: true,
    [Permission.DeleteMonitor]: true,
    [Permission.AddIncludeExcludeFiles]: true,
    [Permission.DeleteIncludeExcludeFiles]: true,
    [Permission.ViewOutreachConfig]: true,
    [Permission.EnableSupportEmailOutreach]: false,
    [Permission.EditSupportEmailOutreach]: false,
    [Permission.ManageSupportEmailOutreachContent]: false,
    [Permission.TestSupportEmailOutreach]: false,
    [Permission.ForceCloseSupportEmailOutreachEvent]: false,
    [Permission.EnableSupportWebhookOutreach]: false,
    [Permission.EditSupportWebhookOutreach]: false,
    [Permission.ManageSupportWebhookOutreachContent]: false,
    [Permission.TestSupportWebhookOutreach]: false,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: false,
    [Permission.EnableSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreachURLs]: true,
    [Permission.TestSubscriberPushOutreach]: true,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: true,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: false,
  },
  [Role.PartnerSupportManagerInternal]: {
    [Permission.ArrangeMonitors]: true,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: true,
    [Permission.EditMonitor]: true,
    [Permission.DeleteMonitor]: true,
    [Permission.AddIncludeExcludeFiles]: true,
    [Permission.DeleteIncludeExcludeFiles]: true,
    [Permission.ViewOutreachConfig]: true,
    [Permission.EnableSupportEmailOutreach]: true,
    [Permission.EditSupportEmailOutreach]: true,
    [Permission.ManageSupportEmailOutreachContent]: true,
    [Permission.TestSupportEmailOutreach]: true,
    [Permission.ForceCloseSupportEmailOutreachEvent]: true,
    [Permission.EnableSupportWebhookOutreach]: true,
    [Permission.EditSupportWebhookOutreach]: true,
    [Permission.ManageSupportWebhookOutreachContent]: true,
    [Permission.TestSupportWebhookOutreach]: true,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: true,
    [Permission.EnableSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreachURLs]: false,
    [Permission.TestSubscriberPushOutreach]: false,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: false,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: false,
  },
  [Role.PlumeAdmin]: {
    [Permission.ArrangeMonitors]: true,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: true,
    [Permission.EditMonitor]: true,
    [Permission.DeleteMonitor]: true,
    [Permission.AddIncludeExcludeFiles]: true,
    [Permission.DeleteIncludeExcludeFiles]: true,
    [Permission.ViewOutreachConfig]: true,
    [Permission.EnableSupportEmailOutreach]: true,
    [Permission.EditSupportEmailOutreach]: true,
    [Permission.ManageSupportEmailOutreachContent]: true,
    [Permission.TestSupportEmailOutreach]: true,
    [Permission.ForceCloseSupportEmailOutreachEvent]: true,
    [Permission.EnableSupportWebhookOutreach]: true,
    [Permission.EditSupportWebhookOutreach]: true,
    [Permission.ManageSupportWebhookOutreachContent]: true,
    [Permission.TestSupportWebhookOutreach]: true,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: true,
    [Permission.EnableSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreach]: true,
    [Permission.EditSubscriberPushOutreachURLs]: true,
    [Permission.TestSubscriberPushOutreach]: true,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: true,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: true,
  },
  [Role.PlumeAdminReadOnly]: {
    [Permission.ArrangeMonitors]: false,
    [Permission.SetTimeRangeMonitor]: true,
    [Permission.ViewMonitorDetail]: true,
    [Permission.ViewMonitorEventDetail]: true,
    [Permission.DownloadOutreachEvent]: true,
    [Permission.AddMonitor]: false,
    [Permission.EditMonitor]: false,
    [Permission.DeleteMonitor]: false,
    [Permission.AddIncludeExcludeFiles]: false,
    [Permission.DeleteIncludeExcludeFiles]: false,
    [Permission.ViewOutreachConfig]: false,
    [Permission.EnableSupportEmailOutreach]: false,
    [Permission.EditSupportEmailOutreach]: false,
    [Permission.ManageSupportEmailOutreachContent]: false,
    [Permission.TestSupportEmailOutreach]: false,
    [Permission.ForceCloseSupportEmailOutreachEvent]: false,
    [Permission.EnableSupportWebhookOutreach]: false,
    [Permission.EditSupportWebhookOutreach]: false,
    [Permission.ManageSupportWebhookOutreachContent]: false,
    [Permission.TestSupportWebhookOutreach]: false,
    [Permission.ForceCloseSupportWebhookOutreachEvent]: false,
    [Permission.EnableSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreach]: false,
    [Permission.EditSubscriberPushOutreachURLs]: false,
    [Permission.TestSubscriberPushOutreach]: false,
    [Permission.ForceCloseSubscriberPushOutreachEvent]: false,
    [Permission.ViewConfiguration]: true,
    [Permission.ModifyConfiguration]: false,
  },
};
